import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Observer from "gsap/Observer";
gsap.registerPlugin(ScrollTrigger, Observer);

const initNextPicAnimation = (): void => {
  const section = document.querySelector<HTMLElement>(".next");
  const pic = document.querySelector<HTMLPictureElement>(".next__pic");

  if (!section || !pic) return;

  const mm = gsap.matchMedia();

  // PC
  mm.add("(min-width: 1025px)", () => {
    gsap.fromTo(
      pic,
      { x: "25%" },
      {
        x: "-50%",
        ease: "none",
        scrollTrigger: {
          trigger: pic,
          start: "top bottom",
          end: "bottom 50%",
          scrub: true,
        },
      }
    );
  });

  // SP
  mm.add("(max-width: 1024px)", () => {
    gsap.fromTo(
      pic,
      { x: "33%" },
      {
        x: "-66%",
        ease: "none",
        scrollTrigger: {
          trigger: pic,
          start: "top bottom",
          end: "bottom 50%",
          scrub: true,
        },
      }
    );
  });
};

initNextPicAnimation();